/**
 * Temporary notice shown for 24 hours after the WC26 matchday schedule migration.
 * Bump `SCORE_REASSIGNMENT_NOTICE_UNTIL_MS` when you deploy the notice (now + 24h, UTC).
 */
export const SCORE_REASSIGNMENT_NOTICE_UNTIL_MS = Date.parse('2026-06-15T04:00:00Z');

export function isScoreReassignmentNoticeVisible(now = Date.now()): boolean {
  return now < SCORE_REASSIGNMENT_NOTICE_UNTIL_MS;
}
